import Viewer from 'viewerjs';
const viewer = (element, binding) => {
  const url = item => {
    return item.src.substring(
      0,
      item.src.indexOf('?') > 0 ? item.src.indexOf('?') : item.src.length
    );
  };
  /* eslint-disable */
  var html = element.innerHTML.trim().replace(/<!--[\w\W\r\n]*?-->/gim, '');
  if (!html)
    var timer = setInterval(function () {
      new Viewer(element, {
        url
      });
      html = element.innerHTML.trim().replace(/<!--[\w\W\r\n]*?-->/gim, '');
      if (html) clearInterval(timer);
    }, 500);
  else
    new Viewer(element, {
      url
    });
};
export default {
  install(Vue) {
    Vue.directive('viewer', viewer);
  }
};



// WEBPACK FOOTER //
// ./src/common/directive.js